(async () => {
  const { Core } = await importModule("Core");
  // const { Swiper } = await importModule('Swiper');

  const CN_ACTIVE = "!active";

  customElements.define(
    "slideshow-thumbnails",
    class extends Core {
      elements = {
        items: "*[data-item]"      
      };

      async render() {
        if (!this.$ref) return;

        await this._initRefSlider();
        this._handleItemsClick();
        this._handleSlideChange();
        this._handleArrowClick();
      }

      async _initRefSlider() {
        await customElements.whenDefined(this.$ref.localName);
        this._updateActive();
      }

      _handleSlideChange() {
        this.$ref.slider.on("slideChange", this._updateActive.bind(this));
      }

      _handleItemsClick() {
        this.$items.map(($item, index) => {
          $item.addEventListener("click", () =>
            this.$ref.slider.slideTo(index)
          );
        });
      }

      _handleArrowClick() {
        this.$leftArrow?.addEventListener("click", () =>
          this.$ref.slider.slidePrev()
        );
        this.$rightArrow?.addEventListener("click", () =>
          this.$ref.slider.slideNext()
        );
      }

      _updateActive() {
        this.active = this.$ref.slider.activeIndex;
        this._scrollToActiveView();
      }

      _scrollToActiveView() {
        if(this.classList.contains("@layout-type:slideshow")){
          this.scroll(
            0,
            this.$activeItem.offsetTop - this.$activeItem.offsetHeight * 3
          );
        }else if (this.classList.contains("@layout-type:grid")) {
          this.scroll(
            this.$activeItem.offsetLeft - this.$activeItem.offsetWidth * 1,
            0
          );
        }
      }

      get $ref() {
        return document.querySelector(this.getAttribute("ref"));
      }

      get $leftArrow() {
        return this.$ref.querySelector(".left-arrow");
      }

      get $rightArrow() {
        return this.$ref.querySelector(".right-arrow");
      }
      

      set active(index) {
        const $item = this.$items[index];
        if (this.$activeItem === $item) return;

        if (this.$activeItem) {
          this.$activeItem.classList.remove(CN_ACTIVE);
        }
        $item.classList.add(CN_ACTIVE);
        this.$activeItem = $item;
      }
    }
  );
})();
